import React, { useEffect, useState } from "react";
import { searchFilesByModule } from "../../services/FilesService/FilesService";
import toast from "react-hot-toast";
import SimpleLoader from "../../components/Loader/SimpleLoader";

const Fotolar = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    searchFilesByModule({ module_code: "fotolar" })
      .then((res) => {
        setPhotos(res.files || []);
      })
      .catch((err) => {
        console.error("Failed to load photos", err);
        toast.error("Фотолар жүктелмеді.");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "photo.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <SimpleLoader className="w-10 h-10 text-purple" />
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-8">
      <h1 className="text-3xl font-bold mb-10 text-center text-[#674DA2]">
        Топтың фотолары
      </h1>

      {photos.length === 0 ? (
        <p className="text-center text-gray-500">Фотолар табылмады.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
          {photos
            // .filter((photo) => !photo.file_name.toLowerCase().endsWith(".heic"))
            .map((photo) => (
              <div
                key={photo.uuid}
                onClick={() => setSelectedPhoto(photo)}
                className="relative cursor-pointer rounded overflow-hidden shadow hover:shadow-lg transition group"
              >
                <img
                  src={photo.file_url}
                  alt={photo.file_name}
                  className="w-full h-72 object-cover group-hover:opacity-90"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black/40 text-white text-xs p-1 text-center truncate">
                  {photo.file_name}
                </div>
              </div>
            ))}
          {selectedPhoto && (
            <div
              className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
              onClick={() => setSelectedPhoto(null)}
            >
              <div
                className="bg-white rounded-lg overflow-hidden max-w-4xl w-full relative"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setSelectedPhoto(null)}
                  className="absolute top-2 right-2 text-white bg-black/60 hover:bg-black p-1 rounded"
                >
                  ✕
                </button>
                <img
                  src={selectedPhoto.file_url}
                  alt={selectedPhoto.file_name}
                  className="w-full max-h-[90vh] object-contain"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Fotolar;
